import { useNavigate } from 'react-router-dom'; // version 5.2.0
import React from "react";
import "./PeopleCard.scss"
import "../pages/HomePage.css"
import { motion } from "framer-motion"

const Card = (props) => {
    const {homepage} = props;
    const {photourl, id, name, location} = props.people;
    const navigate = useNavigate()

    const clickHandler = ()=>{
        navigate(`/team/${id}`);
    }

    return(
        <motion.div className="card-item" initial={{opacity:0}} animate={{opacity:1}} transition={{opacity:{ease: "linear", duration: 0.5}}} layout="position" onClick={()=>clickHandler(id)}>
                <span className="hover-tint people">
                    <img className="people-img-container"
                        id="people-img-container"
                        src={photourl.url}
                        alt={name || ""}
                    />
                </span>
            {homepage?null:
            <div className="card-title">
                <h3>
                    {name}
                </h3>
                <h4>
                    {location}
                </h4>
            </div>
            }
        </motion.div>
    )
}

export default Card;
